<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
/** Same asset as `RemoteIcon` key `SupportChatSendIcon`. */
export let size = 16;
$: maskUrl = `url('${cfgToThemeCdnPath("/support-chat/send.svg")}')`;
</script>

<span
	class="support-chat-send-icon"
	style="width: {size}px; height: {size}px; -webkit-mask-image: {maskUrl}; mask-image: {maskUrl};"
	aria-hidden="true"
/>

<style>
	.support-chat-send-icon {
		display: inline-block;
		flex-shrink: 0;
		background: var(--gradient-secondary);
		-webkit-mask-size: contain;
		-webkit-mask-repeat: no-repeat;
		-webkit-mask-position: center;
		mask-size: contain;
		mask-repeat: no-repeat;
		mask-position: center;
	}
</style>
